import { PastShiftsSwitch } from '../../../../../ui/features/shift-details/components/past-shifts/PastShiftsSwitch';
import { PastShiftsVolunteersAdmin } from '../../../../../ui/features/shift-details/components/past-shifts/PastShiftsVolunteersAdmin';
import { useShiftParticipantsTableFilterConfig } from '../../../../../ui/features/shift/hooks/useShiftParticipantsTableFilterConfig';
import { useAddVolunteers } from '../../../../../ui/features/volunteers-wizard-dialog/hooks/useAddVolunteers';
import { useShiftVolunteerManagementWizardSteps } from '../../../../../ui/features/volunteers-wizard-dialog/hooks/useShiftVolunteerManagementWizardSteps';
import { useMissionsTranslation } from '../../../../../ui/hooks';
import { useDataTableUsingState } from '@juvare/common-data-table-ui/DataTable';
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';
import React from 'react';
export const VolunteersView = ({ pastShiftTab, setPastShiftTab, missionId, onSendMessageToVolunteers, additionalData, useDataTableProviderHandler, defaultRowsPerPage, }) => {
    const { t } = useMissionsTranslation();
    const [showShiftsWithPendingHoursOnly, setShowShiftsWithPendingHoursOnly] = React.useState(false);
    const { dataTableProps, filtersBarProps, reload } = useDataTableUsingState({
        useDataProvider: (request) => useDataTableProviderHandler(request, Object.assign(Object.assign({}, additionalData), { filterData: Object.assign({ showPendingOnly: showShiftsWithPendingHoursOnly }, additionalData.filterData) })),
        defaultSortColumnKey: '', // There is no active sorting, comes sorted from DB
        defaultRowsPerPage,
        rowSelectionEnabled: true,
    });
    const defaultShiftFilter = [
        {
            column: 'startTime',
            op: '<',
            value: Date.now(),
        },
    ];
    const { selectPositionStep, selectShiftStep, selectVolunteersStep, selectMissionShiftStep } = useShiftVolunteerManagementWizardSteps();
    const { onAddVolunteers } = useAddVolunteers({
        steps: [
            missionId
                ? selectShiftStep({
                    additionalShiftFilter: [...defaultShiftFilter, { column: 'missionId', op: '=', value: missionId }],
                })
                : selectMissionShiftStep({ additionalShiftFilters: defaultShiftFilter }),
            selectPositionStep(),
            selectVolunteersStep(),
        ],
        onAfterSubmit: reload,
    });
    const filterConfig = useShiftParticipantsTableFilterConfig();
    return (React.createElement(PastShiftsVolunteersAdmin, { dataTableProps: dataTableProps, filtersBarProps: filtersBarProps, missionId: missionId, filterConfig: filterConfig, showShiftsWithPendingHoursOnly: showShiftsWithPendingHoursOnly, setShowShiftsWithPendingHoursOnly: setShowShiftsWithPendingHoursOnly, defaultRowsPerPage: defaultRowsPerPage, onSendMessageToVolunteers: onSendMessageToVolunteers },
        React.createElement(Button, { sx: {
                width: { xs: '100%', md: 'auto' },
            }, startIcon: React.createElement(AddIcon, null), variant: 'text', onClick: onAddVolunteers, "data-test": 'add-volunteer-button' }, t('shifts.addVolunteers')),
        React.createElement(PastShiftsSwitch, { pastShiftTab: pastShiftTab, setPastShiftTab: setPastShiftTab })));
};
